<div class="mdn-Modal-content">
    <app-swiper-banner *ngIf="swiperBannerConfig"
        [swiperBannerConfig]="swiperBannerConfig"
        (onClickBanner)="onClickBanner($event)">
    </app-swiper-banner>
    <button class="mdn-Button mdn-Button--icon mdn-Button--primaryInverse btn-close" [attr.aria-label]="'Close modal'" (click)="closeModal()">
        <i class="mdn-Icon-fechar mdn-Icon--sm"></i>
    </button>
</div>